<ng-container *ngIf="bookingStore.getCancelSubscriptionStatus$ | async as cancelSubscriptionStatus">
  <mat-card *ngIf="cancelSubscriptionStatus === status.START">
    <mat-card-title class="!flex flex-row justify-between items-center">
      <div *ngIf="data.subscriptionPlan === subscriptionsPlanType.Pro">
        {{ '+BOOKING.CANCEL_BOOKING_MODAL.PRO_TITLE' | translate }}
      </div>
      <div *ngIf="data.subscriptionPlan === subscriptionsPlanType.Plus">
        {{ '+BOOKING.CANCEL_BOOKING_MODAL.PLUS_TITLE' | translate }}
      </div>
      <mat-icon
        class="close-icon"
        gtm="onClose"
        gtmCategory="cancelBookingModal"
        (click)="onClose()"
        >close</mat-icon
      >
    </mat-card-title>
    <mat-card-content>
      <div>
        {{ '+BOOKING.CANCEL_BOOKING_MODAL.DESCRIPTION' | translate }}
      </div>
      <div class="divider"></div>
      <h4>{{ '+BOOKING.CANCEL_BOOKING_MODAL.REASON.TITLE' | translate }}</h4>
      <mat-radio-group class="flex flex-col gap-[8px]" (change)="onReasonSelect($event)">
        <mat-radio-button
          data-at-add-device-modal-radio
          *ngFor="let reason of cancelSubscriptionReasons"
          color="primary"
          [value]="reason"
          gtm="onChange"
          gtmAction="Cancel Booking Reason"
          gtmCategory="cancelBookingModal"
        >
          <span class="device-name">{{ reason.name | translate }}</span>
        </mat-radio-button>
      </mat-radio-group>

      <div class="additionalComments">
        <h4>
          {{ '+BOOKING.CANCEL_BOOKING_MODAL.REMARKS' | translate }}
        </h4>
        <mat-form-field mat-textarea>
          <textarea
            gtm="onTextField"
            gtmAction="Cancel Booking Reason"
            gtmCategory="cancelBookingModal"
            matInput
            [minlength]="minlengthOfComment"
            [maxlength]="maxlengthOfComment"
            [(ngModel)]="additionalComment"
            placeholder=" {{ '+BOOKING.CANCEL_BOOKING_MODAL.REMARKS_DESC' | translate }}"
          ></textarea>
        </mat-form-field>

        <span class="flex justify-end items-center"
          >{{ additionalComment.length || 0 }}/{{ maxlengthOfComment }}</span
        >
      </div>
    </mat-card-content>
    <mat-card-actions class="!flex flex-row justify-end items-center">
      <button
        mat-raised-button
        color="primary"
        gtm="onConfirm"
        gtmAction="Cancel booking"
        gtmCategory="cancelBookingModal"
        [disabled]="isDisabledWhenMandatoryCommentEmpty()"
        (click)="onCancelBooking()"
      >
        {{ 'GENERAL.BUTTON.CONTINUE' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>

  <mat-card *ngIf="cancelSubscriptionStatus === status.SUCCESS">
    <mat-card-content class="!flex flex-col gap-[24px] justify-end items-center">
      <img src="./assets/img/installer-guy.png" />
      <h1>{{ '+BOOKING.CANCEL_BOOKING_MODAL.SUCCESS.DESC' | translate }}</h1>
    </mat-card-content>
    <mat-card-actions class="!flex flex-row justify-center items-center">
      <button
        mat-stroked-button
        color="primary"
        class="fill-btn"
        gtm="onClose"
        gtmCategory="cancelBookingModal"
        (click)="onClose()"
      >
        {{ '+BOOKING.CANCEL_BOOKING_MODAL.SUCCESS.BUTTON' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>

  <mat-card *ngIf="cancelSubscriptionStatus === status.FAILED">
    <mat-card-title class="!flex flex-row justify-end items-center">
      <mat-icon
        class="close-icon"
        gtm="onClose"
        gtmCategory="cancelBookingModal"
        (click)="onClose()"
        >close</mat-icon
      >
    </mat-card-title>
    <mat-card-content class="!flex flex-col gap-[24px] justify-start items-center">
      <img src="./assets/img/installer-error.png" />
      <h1>{{ '+BOOKING.CANCEL_BOOKING_MODAL.FAILED.DESC' | translate }}</h1>
    </mat-card-content>
    <mat-card-actions class="!flex flex-row justify-end items-center">
      <button
        mat-raised-button
        color="primary"
        class="fill-btn"
        gtm="onTryAgain"
        gtmAction="Retry cancel booking"
        gtmCategory="cancelBookingModal"
        (click)="onTryAgain()"
      >
        {{ 'GENERAL.BUTTON.TRY_AGAIN' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</ng-container>
